// src/plugins/stockHelper.js
const StockHelper = {
  install(Vue) {

    Vue.prototype.$getSimpleStockMessage = function(item) {
      const quantity = (typeof item.empresa_id !== 'undefined' && item.empresa_id != 0) 
        ? item.existencia 
        : item.quantity;

      if (quantity >= 100) {
        return 'Disponible';
      } else if (quantity >= 1) {
        return 'Stock limitado';
      } else {
        return 'Agotado';
      }
    };

    Vue.prototype.$getSimpleStockClass = function(item) {
      const quantity = (typeof item.empresa_id !== 'undefined' && item.empresa_id != 0) 
        ? item.existencia 
        : item.quantity;

      if (quantity >= 100) {
        return 'stock-available';
      } else if (quantity >= 1) {
        return 'stock-low';
      } else {
        return 'stock-out';
      }
    };

  }
};

export default StockHelper;